<template>
  <div class="home">
    <NavbarView />

    <main class="main-content">
      <Section1View id="section1" class="fullscreen-section"/>
<Section7View id="section7" class="fullscreen-section" />
<Section2View id="section2" class="fullscreen-section" />
<Section3View id="section3" class="fullscreen-section" />
<Section5View id="section5" class="fullscreen-section" />
<Section4View id="section4" class="fullscreen-section" />
<Section6View id="section6" class="fullscreen-section" />
<!--       <Section8View class="fullscreen-section" />-->
    </main>

    <FooterView id="footer" />
  </div>
</template>



<script>
import NavbarView from '@/components/NavbarView.vue'
import FooterView from '@/components/FooterView.vue'
import Section1View from "@/components/Section1View";
import Section2View from "@/components/Section2View";
import Section3View from "@/components/Section3View";
import Section4View from "@/components/Section4View";
import Section5View from "@/components/Section5View";
import Section6View from "@/components/Section6View";
import Section7View from "@/components/Section7View";
//import Section8View from "@/components/Section8View";

export default {
  name: 'HomeView',
  components: {
    NavbarView,
    FooterView,
    Section1View,
    Section2View,
    Section3View,
    Section4View,
    Section5View,
    Section6View,
    Section7View,
    //Section8View,
  }
}
</script>
<style scoped>
.home {
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  scroll-snap-type: y mandatory;
  overflow-y: scroll;
  height: 120vh;
}

.fullscreen-section {
  min-height: 120vh;
  scroll-snap-align: start;
}
</style>